<div class="col-md-12">
    <div class="card card-accent-success animated fadeIn">

        <div class="card-header-buscador">
            <i class="fa fa-align-justify"></i> <strong>Higiene</strong>
        </div>

        <div class="card-body-grid">

            <p-table #tableSearch autoLayout="true" [value]="frSanidadExtInsp"
                     [columns]="colsFrecRedSanidadExt" sortField="GrupoFrDescripcion" sortOrder="-1"
                     styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                     [ngClass]="displayGridHidden(frSanidadExtInsp)">

                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                    <tr>
                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                            <span *ngIf="(col.field!=='Link' && col.field!=='PorcentajeFrecuenciaFisica' && col.field!=='PorcentajeFrecuenciaLab' && col.field!=='PorcentajePifFisica' && col.field!=='PorcentajePifLab' && col.field!=='PorcentajeNacionalFisica' && col.field!=='PorcentajeNacionalLab' )">
                                {{ rowData[col.field] }}
                            </span>

                            <span *ngIf="col.field === 'PorcentajeFrecuenciaFisica'" [ngClass]="'cumplefr'">
                                {{ rowData[col.field] | number:'1.0-1':'es-ES' }} %
                            </span>
                            <span *ngIf="rowData[col.field] !== null && col.field === 'PorcentajeFrecuenciaLab'" [ngClass]="'cumplefr'">
                                {{ rowData[col.field] | number:'1.0-1':'es-ES' }} %
                            </span>
                            <span *ngIf="rowData[col.field] === null && col.field === 'PorcentajeFrecuenciaLab'" [ngClass]="'cumplefr'">
                                &nbsp;
                            </span>

                            <span *ngIf="col.field === 'PorcentajePifFisica'"
                                  [ngClass]="rowData[col.field] < rowData['PorcentajeFrecuenciaFisica'] ? 'nocumplefr' : 'cumplefr'"
                                  ngbTooltip="{{ rowData['TotalConFisicaPif'] }} de {{ rowData['TotalPif'] }}">
                                {{ rowData[col.field] | number:'1.0-1':'es-ES' }} %
                            </span>

                            <ng-container *ngIf="col.field === 'PorcentajePifLab'">
                                <span *ngIf="rowData['PorcentajeFrecuenciaLab'] !== null && rowData['PorcentajeFrecuenciaLab'] !== 0"
                                      [ngClass]="rowData[col.field] < rowData['PorcentajeFrecuenciaLab'] ? 'nocumplefr' : 'cumplefr'"
                                      ngbTooltip="{{ rowData['TotalConLabPif'] }} de {{ rowData['TotalPif'] }}">
                                    {{ rowData[col.field] | number:'1.0-1':'es-ES' }} %
                                </span>
                                <span *ngIf="rowData['PorcentajeFrecuenciaLab'] === null || rowData['PorcentajeFrecuenciaLab'] === 0">
                                    &nbsp;
                                </span>
                            </ng-container>

                            <span *ngIf="col.field === 'PorcentajeNacionalFisica'" [ngClass]="rowData[col.field] < rowData['PorcentajeFrecuenciaFisica'] ? 'nocumplefr' : 'cumplefr'"
                                  ngbTooltip="{{ rowData['TotalConFisicaNacional'] }} de {{ rowData['TotalNacional'] }}">
                                {{ rowData[col.field] | number:'1.0-1':'es-ES' }} %
                            </span>

                            <ng-container *ngIf="col.field === 'PorcentajeNacionalLab'">
                                <span *ngIf="rowData['PorcentajeFrecuenciaLab'] !== null && rowData['PorcentajeFrecuenciaLab'] !== 0"
                                      [ngClass]="rowData[col.field] < rowData['PorcentajeFrecuenciaLab'] ? 'nocumplefr' : 'cumplefr'"
                                      ngbTooltip="{{ rowData['TotalConLabNacional'] }} de {{ rowData['TotalNacional'] }}">
                                    {{ rowData[col.field] | number:'1.0-1':'es-ES' }} %
                                </span>
                                <span *ngIf="rowData['PorcentajeFrecuenciaLab'] === null || rowData['PorcentajeFrecuenciaLab'] === 0">
                                    &nbsp;
                                </span>
                            </ng-container>

                            <div *ngIf="col.field==='Link'" class="btn-group">

                                <div *ngIf="esRechazoParcial">
                                    <!--ICONO rechazo parcial-->
                                    <img class="icono-info-grid" src="{{null | IconoProdsEmbsRp}}" container="body" />
                                </div>
                                
                                <div *ngIf="esRechazoParcial">
                                    <div *ngIf="rowData['Aceptado'] === true"><img class="icono-info-grid-small" src="{{rowData['Aceptado'] | IconoProdsEmbsRpAceptado}}" container="body" /></div>
                                    <div *ngIf="rowData['Aceptado'] === false"><img class="icono-info-grid-small" src="{{rowData['Aceptado'] | IconoProdsEmbsRpAceptado}}" container="body" /></div>
                                </div>

                            </div>

                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
